import styled from '@emotion/styled';
import { bodyM } from '@teamsparta/stack-font';
import { vars } from '@teamsparta/stack-tokens';

import { DESKTOP } from '@/styles/themes';

const DESKTOP_WIDTH = 796;
export const Container = styled.div`
  position: relative;
  padding: 50px 16px;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background-color: ${vars.neutral[100]};
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 360px;
  ${DESKTOP} {
    padding: 100px 0;
  }

  .desktop {
    display: none;
    ${DESKTOP} {
      display: block;
    }
  }
  .mobile {
    ${DESKTOP} {
      display: none;
    }
  }
`;
export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  ${DESKTOP} {
    flex-direction: row;
  }
`;
export const WebinarContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  ${DESKTOP} {
    width: ${DESKTOP_WIDTH}px;
  }
`;
export const Wrapper = styled.div`
  padding-top: 60px;
  ${DESKTOP} {
    padding-top: 80px;
  }
`;
export const Divider = styled.div`
  margin: 60px 0;
  height: 1px;
  background-color: ${vars.neutral[80]};
  ${DESKTOP} {
    margin: 80px 0;
  }
`;
export const MoveToTop = styled.button`
  display: flex;
  margin: 80px auto;
  align-items: center;
  border: none;
  ${bodyM};
  color: ${vars.neutral[50]};
  cursor: pointer;
  background-color: transparent;
  gap: 6px;
  &.desktop {
    ${DESKTOP} {
      display: inherit;
    }
  }
`;

export const Aside = styled.aside`
  position: relative;
  left: -16px;

  width: calc(100% + 32px);
  height: fit-content;
  padding: 60px 16px;

  display: flex;
  flex-direction: column;

  border-top: 10px solid #222425;

  ${DESKTOP} {
    position: sticky;
    top: 80px;
    left: unset;

    width: 364px;
    padding: 0;

    gap: 24px;
    border-top: none;
  }
`;
